"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageLogsReport = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsLogsReportFilter = require("../../components/DmsLogsReport/DmsLogsReportFilter");
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsLogsReport component renders the batch table.
 * Renders a DmsPage layout with a DmsAltBox containing the DmsLogsReportFilter component.
 * @component
 * @example
 * return (
 *   <DmsLogsReportFilter />
 * )
 */

const DmsPageLogsReport = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: _reactIntlUniversal.default.get("LogsReport").d("Logs Report")
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("LogsReport").d("Logs Report"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsLogsReportFilter.DmsLogsReportFilter, null))));
};
exports.DmsPageLogsReport = DmsPageLogsReport;